// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from "./client";
import { client } from "./client.gen";
import type {
  AddItemsToCartShopAgentCartsCartIdItemsPostData,
  AddItemsToCartShopAgentCartsCartIdItemsPostErrors,
  AddItemsToCartShopAgentCartsCartIdItemsPostResponses,
  CreateCartShopAgentCartsPostData,
  CreateCartShopAgentCartsPostErrors,
  CreateCartShopAgentCartsPostResponses,
  CreateCollectionShopAgentCollectionsPostData,
  CreateCollectionShopAgentCollectionsPostErrors,
  CreateCollectionShopAgentCollectionsPostResponses,
  CreateSavedBrandShopAgentSavedBrandsPostData,
  CreateSavedBrandShopAgentSavedBrandsPostErrors,
  CreateSavedBrandShopAgentSavedBrandsPostResponses,
  CreateSavedSearchShopAgentSavedSearchesPostData,
  CreateSavedSearchShopAgentSavedSearchesPostErrors,
  CreateSavedSearchShopAgentSavedSearchesPostResponses,
  CreateUserShopAgentUsersMePostData,
  CreateUserShopAgentUsersMePostErrors,
  CreateUserShopAgentUsersMePostResponses,
  CuratedSearchShopAgentSearchCuratedPostData,
  CuratedSearchShopAgentSearchCuratedPostErrors,
  CuratedSearchShopAgentSearchCuratedPostResponses,
  DeleteCollectionShopAgentCollectionsCollectionIdDeleteData,
  DeleteCollectionShopAgentCollectionsCollectionIdDeleteErrors,
  DeleteCollectionShopAgentCollectionsCollectionIdDeleteResponses,
  DeleteCosimoAgentThreadShopAgentThreadsCosimoAgentThreadIdDeleteData,
  DeleteCosimoAgentThreadShopAgentThreadsCosimoAgentThreadIdDeleteErrors,
  DeleteCosimoAgentThreadShopAgentThreadsCosimoAgentThreadIdDeleteResponses,
  DeleteSavedBrandShopAgentSavedBrandsSavedBrandIdDeleteData,
  DeleteSavedBrandShopAgentSavedBrandsSavedBrandIdDeleteErrors,
  DeleteSavedBrandShopAgentSavedBrandsSavedBrandIdDeleteResponses,
  DeleteSavedSearchShopAgentSavedSearchesSavedSearchIdDeleteData,
  DeleteSavedSearchShopAgentSavedSearchesSavedSearchIdDeleteErrors,
  DeleteSavedSearchShopAgentSavedSearchesSavedSearchIdDeleteResponses,
  ExecuteUserDeletionData,
  ExecuteUserDeletionErrors,
  ExecuteUserDeletionResponses,
  GetAttributesByFacetsShopAgentCategoryAttributesAggregatedAttributesByFacetsPostData,
  GetAttributesByFacetsShopAgentCategoryAttributesAggregatedAttributesByFacetsPostErrors,
  GetAttributesByFacetsShopAgentCategoryAttributesAggregatedAttributesByFacetsPostResponses,
  GetCartShopAgentCartsCartIdGetData,
  GetCartShopAgentCartsCartIdGetErrors,
  GetCartShopAgentCartsCartIdGetResponses,
  GetCategoryCountsShopAgentCategoryAttributesCategoryCountsPostData,
  GetCategoryCountsShopAgentCategoryAttributesCategoryCountsPostErrors,
  GetCategoryCountsShopAgentCategoryAttributesCategoryCountsPostResponses,
  GetCollectionShopAgentCollectionsCollectionIdGetData,
  GetCollectionShopAgentCollectionsCollectionIdGetErrors,
  GetCollectionShopAgentCollectionsCollectionIdGetResponses,
  GetCosimoAgentThreadsShopAgentThreadsCosimoAgentGetData,
  GetCosimoAgentThreadsShopAgentThreadsCosimoAgentGetErrors,
  GetCosimoAgentThreadsShopAgentThreadsCosimoAgentGetResponses,
  GetHomeCuratedRailsShopAgentSearchCuratedHomeGetData,
  GetHomeCuratedRailsShopAgentSearchCuratedHomeGetErrors,
  GetHomeCuratedRailsShopAgentSearchCuratedHomeGetResponses,
  GetPublicCollectionShopAgentCollectionsPublicCollectionIdGetData,
  GetPublicCollectionShopAgentCollectionsPublicCollectionIdGetErrors,
  GetPublicCollectionShopAgentCollectionsPublicCollectionIdGetResponses,
  GetSavedBrandByNameShopAgentSavedBrandsByNameBrandNameGetData,
  GetSavedBrandByNameShopAgentSavedBrandsByNameBrandNameGetErrors,
  GetSavedBrandByNameShopAgentSavedBrandsByNameBrandNameGetResponses,
  GetSearchQueryShopAgentSearchQueriesSearchIdGetData,
  GetSearchQueryShopAgentSearchQueriesSearchIdGetErrors,
  GetSearchQueryShopAgentSearchQueriesSearchIdGetResponses,
  GetShopAgentChatHistoryShopAgentThreadsShopAgentThreadIdGetData,
  GetShopAgentChatHistoryShopAgentThreadsShopAgentThreadIdGetErrors,
  GetShopAgentChatHistoryShopAgentThreadsShopAgentThreadIdGetResponses,
  GetThreadLatestQueryShopAgentSearchQueriesThreadsThreadIdLatestGetData,
  GetThreadLatestQueryShopAgentSearchQueriesThreadsThreadIdLatestGetErrors,
  GetThreadLatestQueryShopAgentSearchQueriesThreadsThreadIdLatestGetResponses,
  GetUserCartsShopAgentCartsGetData,
  GetUserCartsShopAgentCartsGetErrors,
  GetUserCartsShopAgentCartsGetResponses,
  GetUserDeletionData,
  GetUserDeletionErrors,
  GetUserDeletionResponses,
  GetUserShopAgentUsersMeGetData,
  GetUserShopAgentUsersMeGetErrors,
  GetUserShopAgentUsersMeGetResponses,
  ListCollectionsForUserShopAgentCollectionsGetData,
  ListCollectionsForUserShopAgentCollectionsGetErrors,
  ListCollectionsForUserShopAgentCollectionsGetResponses,
  ListConnectedAppsShopAgentMcpConnectedAppsGetData,
  ListConnectedAppsShopAgentMcpConnectedAppsGetErrors,
  ListConnectedAppsShopAgentMcpConnectedAppsGetResponses,
  ListLandingPagesShopAgentSearchCuratedLandingPagesGetData,
  ListLandingPagesShopAgentSearchCuratedLandingPagesGetResponses,
  ListSavedBrandsForUserShopAgentSavedBrandsGetData,
  ListSavedBrandsForUserShopAgentSavedBrandsGetErrors,
  ListSavedBrandsForUserShopAgentSavedBrandsGetResponses,
  ListSavedSearchesForUserShopAgentSavedSearchesGetData,
  ListSavedSearchesForUserShopAgentSavedSearchesGetErrors,
  ListSavedSearchesForUserShopAgentSavedSearchesGetResponses,
  ListUserSearchQueriesShopAgentSearchQueriesGetData,
  ListUserSearchQueriesShopAgentSearchQueriesGetErrors,
  ListUserSearchQueriesShopAgentSearchQueriesGetResponses,
  MetricsMetricsGetData,
  MetricsMetricsGetResponses,
  PreviewUserDeletionData,
  PreviewUserDeletionErrors,
  PreviewUserDeletionResponses,
  RemoveItemsFromCartShopAgentCartsCartIdItemsDeleteData,
  RemoveItemsFromCartShopAgentCartsCartIdItemsDeleteErrors,
  RemoveItemsFromCartShopAgentCartsCartIdItemsDeleteResponses,
  RevokeConnectedAppShopAgentMcpConnectedAppsDeleteData,
  RevokeConnectedAppShopAgentMcpConnectedAppsDeleteErrors,
  RevokeConnectedAppShopAgentMcpConnectedAppsDeleteResponses,
  ShopAgentBrandDiscoveryGetDetailsData,
  ShopAgentBrandDiscoveryGetDetailsErrors,
  ShopAgentBrandDiscoveryGetDetailsResponses,
  ShopAgentBrandGetByNameData,
  ShopAgentBrandGetByNameErrors,
  ShopAgentBrandGetByNameResponses,
  ShopAgentBrandGetShoppingOptionsData,
  ShopAgentBrandGetShoppingOptionsErrors,
  ShopAgentBrandGetShoppingOptionsResponses,
  ShopAgentBrandIndexPrefixSearchData,
  ShopAgentBrandIndexPrefixSearchErrors,
  ShopAgentBrandIndexPrefixSearchResponses,
  ShopAgentBrandIndexSearchByBrandsData,
  ShopAgentBrandIndexSearchByBrandsErrors,
  ShopAgentBrandIndexSearchByBrandsResponses,
  ShopAgentBrandIndexSearchFromQueryData,
  ShopAgentBrandIndexSearchFromQueryErrors,
  ShopAgentBrandIndexSearchFromQueryResponses,
  ShopAgentBrandIndexSearchFromTextData,
  ShopAgentBrandIndexSearchFromTextErrors,
  ShopAgentBrandIndexSearchFromTextResponses,
  ShopAgentBrandInternalGetTopCategoriesData,
  ShopAgentBrandInternalGetTopCategoriesErrors,
  ShopAgentBrandInternalGetTopCategoriesResponses,
  ShopAgentBrandInternalIndexSearchByBrandsData,
  ShopAgentBrandInternalIndexSearchByBrandsErrors,
  ShopAgentBrandInternalIndexSearchByBrandsResponses,
  ShopAgentBrandListBrandsData,
  ShopAgentBrandListBrandsResponses,
  ShopAgentBrandPublicGetByNameData,
  ShopAgentBrandPublicGetByNameErrors,
  ShopAgentBrandPublicGetByNameResponses,
  ShopAgentBrandPublicListData,
  ShopAgentBrandPublicListResponses,
  ShopAgentCatalogGetProductGroupByUuidData,
  ShopAgentCatalogGetProductGroupByUuidErrors,
  ShopAgentCatalogGetProductGroupByUuidResponses,
  ShopAgentCatalogHydrateProductsData,
  ShopAgentCatalogHydrateProductsErrors,
  ShopAgentCatalogHydrateProductsResponses,
  ShopAgentCatalogProductPublicBrowseByBrandData,
  ShopAgentCatalogProductPublicBrowseByBrandErrors,
  ShopAgentCatalogProductPublicBrowseByBrandResponses,
  ShopAgentCatalogProductPublicGetByUuidData,
  ShopAgentCatalogProductPublicGetByUuidErrors,
  ShopAgentCatalogProductPublicGetByUuidResponses,
  ShopAgentCatalogProductPublicJsonLdData,
  ShopAgentCatalogProductPublicJsonLdErrors,
  ShopAgentCatalogProductPublicJsonLdResponses,
  ShopAgentCatalogProductPublicStatusData,
  ShopAgentCatalogProductPublicStatusErrors,
  ShopAgentCatalogProductPublicStatusResponses,
  ShopAgentGetBrowseMenuData,
  ShopAgentGetBrowseMenuErrors,
  ShopAgentGetBrowseMenuResponses,
  ShopAgentGetSearchPageData,
  ShopAgentGetSearchPageErrors,
  ShopAgentGetSearchPageResponses,
  ShopAgentSearchInternalProductsData,
  ShopAgentSearchInternalProductsErrors,
  ShopAgentSearchInternalProductsResponses,
  ShopAgentSearchProductsData,
  ShopAgentSearchProductsErrors,
  ShopAgentSearchProductsResponses,
  ShopAgentSearchSimilarProductsData,
  ShopAgentSearchSimilarProductsErrors,
  ShopAgentSearchSimilarProductsResponses,
  SuggestAttributesShopAgentAttributeAgentSuggestPostData,
  SuggestAttributesShopAgentAttributeAgentSuggestPostErrors,
  SuggestAttributesShopAgentAttributeAgentSuggestPostResponses,
  UpdateCartShopAgentCartsCartIdPutData,
  UpdateCartShopAgentCartsCartIdPutErrors,
  UpdateCartShopAgentCartsCartIdPutResponses,
  UpdateCollectionShopAgentCollectionsCollectionIdPatchData,
  UpdateCollectionShopAgentCollectionsCollectionIdPatchErrors,
  UpdateCollectionShopAgentCollectionsCollectionIdPatchResponses,
  UpdateSavedBrandShopAgentSavedBrandsSavedBrandIdPatchData,
  UpdateSavedBrandShopAgentSavedBrandsSavedBrandIdPatchErrors,
  UpdateSavedBrandShopAgentSavedBrandsSavedBrandIdPatchResponses,
  UpdateSavedSearchShopAgentSavedSearchesSavedSearchIdPatchData,
  UpdateSavedSearchShopAgentSavedSearchesSavedSearchIdPatchErrors,
  UpdateSavedSearchShopAgentSavedSearchesSavedSearchIdPatchResponses,
  UpdateUserPreferencesShopAgentUsersMePreferencesPreferenceTypePatchData,
  UpdateUserPreferencesShopAgentUsersMePreferencesPreferenceTypePatchErrors,
  UpdateUserPreferencesShopAgentUsersMePreferencesPreferenceTypePatchResponses,
  UpdateUserShopAgentUsersMePatchData,
  UpdateUserShopAgentUsersMePatchErrors,
  UpdateUserShopAgentUsersMePatchResponses,
} from "./types.gen";

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
> = Options2<TData, ThrowOnError> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * Metrics
 *
 * Endpoint that serves Prometheus metrics.
 */
export const metricsMetricsGet = <ThrowOnError extends boolean = false>(
  options?: Options<MetricsMetricsGetData, ThrowOnError>
) => {
  return (options?.client ?? client).get<MetricsMetricsGetResponses, unknown, ThrowOnError>({
    url: "/metrics",
    ...options,
  });
};

/**
 * Preview User Deletion
 */
export const previewUserDeletion = <ThrowOnError extends boolean = false>(
  options: Options<PreviewUserDeletionData, ThrowOnError>
) => {
  return (options.client ?? client).post<
    PreviewUserDeletionResponses,
    PreviewUserDeletionErrors,
    ThrowOnError
  >({
    url: "/shop-agent/admin/user-deletions/preview",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Get User Deletion
 */
export const getUserDeletion = <ThrowOnError extends boolean = false>(
  options: Options<GetUserDeletionData, ThrowOnError>
) => {
  return (options.client ?? client).get<
    GetUserDeletionResponses,
    GetUserDeletionErrors,
    ThrowOnError
  >({
    url: "/shop-agent/admin/user-deletions/{operation_id}",
    ...options,
  });
};

/**
 * Execute User Deletion
 */
export const executeUserDeletion = <ThrowOnError extends boolean = false>(
  options: Options<ExecuteUserDeletionData, ThrowOnError>
) => {
  return (options.client ?? client).post<
    ExecuteUserDeletionResponses,
    ExecuteUserDeletionErrors,
    ThrowOnError
  >({
    url: "/shop-agent/admin/user-deletions/{operation_id}/execute",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Suggest Attributes
 *
 * Suggest product attributes based on search results.
 *
 * This endpoint uses Gemini 2.5 Flash to analyze attribute occurrence counts
 * and suggest the 5 most useful attributes for refining a search.
 */
export const suggestAttributesShopAgentAttributeAgentSuggestPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<SuggestAttributesShopAgentAttributeAgentSuggestPostData, ThrowOnError>
) => {
  return (options.client ?? client).post<
    SuggestAttributesShopAgentAttributeAgentSuggestPostResponses,
    SuggestAttributesShopAgentAttributeAgentSuggestPostErrors,
    ThrowOnError
  >({
    url: "/shop-agent/attribute-agent/suggest",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Get Browse Menu Endpoint
 *
 * Get the browse menu configuration.
 *
 * Returns the browse menu as a validated list of BrowseMenuItem objects.
 * The menu is loaded from the path specified by dynamic settings in Firestore,
 * falling back to the BROWSE_MENU_PATH static setting if no dynamic path
 * is configured.
 *
 * The browse menu path can be updated at runtime in Firestore without
 * requiring a service restart. When the path changes, the cache is
 * automatically invalidated and the next request loads from the new path.
 *
 * Args:
 * root_nodes_only: If True, return only the root category nodes
 * (menswear, womenswear, kidswear, beauty). Defaults to False.
 *
 * ETag Support:
 * The response includes an ETag header derived from the browse menu content.
 * Clients can send an If-None-Match header with the ETag value to receive
 * a 304 Not Modified response if the content hasn't changed. The ETag will
 * change when the file content changes, even if the filename stays the same.
 *
 * Request Headers:
 * If-None-Match: Optional ETag value for conditional request
 *
 * Response Headers:
 * ETag: Current entity tag for the browse menu
 *
 * Returns:
 * 200: List of BrowseMenuItem objects representing the browse navigation tree.
 * 304: Not Modified if If-None-Match header matches current ETag.
 *
 * Raises:
 * HTTPException 404: If the browse menu file is not found
 * HTTPException 500: If the browse menu fails to load or validate
 */
export const shopAgentGetBrowseMenu = <ThrowOnError extends boolean = false>(
  options?: Options<ShopAgentGetBrowseMenuData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    ShopAgentGetBrowseMenuResponses,
    ShopAgentGetBrowseMenuErrors,
    ThrowOnError
  >({
    url: "/shop-agent/browse-menu",
    ...options,
  });
};

/**
 * Get User Carts
 *
 * Get all carts for authenticated user (requires authentication via X-Octogen-User-ID header).
 */
export const getUserCartsShopAgentCartsGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetUserCartsShopAgentCartsGetData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetUserCartsShopAgentCartsGetResponses,
    GetUserCartsShopAgentCartsGetErrors,
    ThrowOnError
  >({
    url: "/shop-agent/carts/",
    ...options,
  });
};

/**
 * Create Cart
 *
 * Create a new cart for authenticated user (requires authentication via X-Octogen-User-ID header).
 */
export const createCartShopAgentCartsPost = <ThrowOnError extends boolean = false>(
  options: Options<CreateCartShopAgentCartsPostData, ThrowOnError>
) => {
  return (options.client ?? client).post<
    CreateCartShopAgentCartsPostResponses,
    CreateCartShopAgentCartsPostErrors,
    ThrowOnError
  >({
    url: "/shop-agent/carts/",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Get Cart
 *
 * Get a specific cart by ID (requires authentication via X-Octogen-User-ID header, validates ownership).
 */
export const getCartShopAgentCartsCartIdGet = <ThrowOnError extends boolean = false>(
  options: Options<GetCartShopAgentCartsCartIdGetData, ThrowOnError>
) => {
  return (options.client ?? client).get<
    GetCartShopAgentCartsCartIdGetResponses,
    GetCartShopAgentCartsCartIdGetErrors,
    ThrowOnError
  >({
    url: "/shop-agent/carts/{cart_id}",
    ...options,
  });
};

/**
 * Update Cart
 *
 * Replace the product list for a specific cart (requires authentication via X-Octogen-User-ID header, validates ownership).
 */
export const updateCartShopAgentCartsCartIdPut = <ThrowOnError extends boolean = false>(
  options: Options<UpdateCartShopAgentCartsCartIdPutData, ThrowOnError>
) => {
  return (options.client ?? client).put<
    UpdateCartShopAgentCartsCartIdPutResponses,
    UpdateCartShopAgentCartsCartIdPutErrors,
    ThrowOnError
  >({
    url: "/shop-agent/carts/{cart_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Remove Items From Cart
 *
 * Remove products from a specific cart (requires authentication via X-Octogen-User-ID header, validates ownership).
 */
export const removeItemsFromCartShopAgentCartsCartIdItemsDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<RemoveItemsFromCartShopAgentCartsCartIdItemsDeleteData, ThrowOnError>
) => {
  return (options.client ?? client).delete<
    RemoveItemsFromCartShopAgentCartsCartIdItemsDeleteResponses,
    RemoveItemsFromCartShopAgentCartsCartIdItemsDeleteErrors,
    ThrowOnError
  >({
    url: "/shop-agent/carts/{cart_id}/items",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Add Items To Cart
 *
 * Add products (and optional variants) to a specific cart (requires authentication via X-Octogen-User-ID header, validates ownership).
 *
 * The `product_ids` and `product_variants` arrays are kept **index-aligned**.
 * New products are appended in the order they appear in the request **only**
 * if the product is not already in the cart. Variants are appended together
 * with their corresponding product IDs, guaranteeing that both arrays always
 * have the same length and preserve positional semantics.
 */
export const addItemsToCartShopAgentCartsCartIdItemsPost = <ThrowOnError extends boolean = false>(
  options: Options<AddItemsToCartShopAgentCartsCartIdItemsPostData, ThrowOnError>
) => {
  return (options.client ?? client).post<
    AddItemsToCartShopAgentCartsCartIdItemsPostResponses,
    AddItemsToCartShopAgentCartsCartIdItemsPostErrors,
    ThrowOnError
  >({
    url: "/shop-agent/carts/{cart_id}/items",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Get Brand Discovery Details
 *
 * Public-backed explorer metadata projected from the shared profile.
 */
export const shopAgentBrandDiscoveryGetDetails = <ThrowOnError extends boolean = false>(
  options: Options<ShopAgentBrandDiscoveryGetDetailsData, ThrowOnError>
) => {
  return (options.client ?? client).get<
    ShopAgentBrandDiscoveryGetDetailsResponses,
    ShopAgentBrandDiscoveryGetDetailsErrors,
    ThrowOnError
  >({
    url: "/shop-agent/catalog/brand/discovery/{brand_name}",
    ...options,
  });
};

/**
 * Get Brand
 */
export const shopAgentBrandGetByName = <ThrowOnError extends boolean = false>(
  options: Options<ShopAgentBrandGetByNameData, ThrowOnError>
) => {
  return (options.client ?? client).get<
    ShopAgentBrandGetByNameResponses,
    ShopAgentBrandGetByNameErrors,
    ThrowOnError
  >({
    url: "/shop-agent/catalog/brand/get/{brand_name}",
    ...options,
  });
};

/**
 * Get Brand Shopping Options Endpoint
 */
export const shopAgentBrandGetShoppingOptions = <ThrowOnError extends boolean = false>(
  options: Options<ShopAgentBrandGetShoppingOptionsData, ThrowOnError>
) => {
  return (options.client ?? client).get<
    ShopAgentBrandGetShoppingOptionsResponses,
    ShopAgentBrandGetShoppingOptionsErrors,
    ThrowOnError
  >({
    url: "/shop-agent/catalog/brand/get/{brand_name}/shopping-options",
    ...options,
  });
};

/**
 * Get Brand Top Categories Internal Endpoint
 */
export const shopAgentBrandInternalGetTopCategories = <ThrowOnError extends boolean = false>(
  options: Options<ShopAgentBrandInternalGetTopCategoriesData, ThrowOnError>
) => {
  return (options.client ?? client).get<
    ShopAgentBrandInternalGetTopCategoriesResponses,
    ShopAgentBrandInternalGetTopCategoriesErrors,
    ThrowOnError
  >({
    url: "/shop-agent/catalog/brand/internal/get/{brand_name}/top-categories",
    ...options,
  });
};

/**
 * Search Brands Index By Brands Internal
 *
 * Keep internal-token auth and the bridge's shorter whole-call budget.
 */
export const shopAgentBrandInternalIndexSearchByBrands = <ThrowOnError extends boolean = false>(
  options: Options<ShopAgentBrandInternalIndexSearchByBrandsData, ThrowOnError>
) => {
  return (options.client ?? client).post<
    ShopAgentBrandInternalIndexSearchByBrandsResponses,
    ShopAgentBrandInternalIndexSearchByBrandsErrors,
    ThrowOnError
  >({
    url: "/shop-agent/catalog/brand/internal/search-index/by-brands",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * List Brands
 */
export const shopAgentBrandListBrands = <ThrowOnError extends boolean = false>(
  options?: Options<ShopAgentBrandListBrandsData, ThrowOnError>
) => {
  return (options?.client ?? client).get<ShopAgentBrandListBrandsResponses, unknown, ThrowOnError>({
    url: "/shop-agent/catalog/brand/list",
    ...options,
  });
};

/**
 * Get Brand Public
 *
 * Public profile and content; operational failures remain errors.
 */
export const shopAgentBrandPublicGetByName = <ThrowOnError extends boolean = false>(
  options: Options<ShopAgentBrandPublicGetByNameData, ThrowOnError>
) => {
  return (options.client ?? client).get<
    ShopAgentBrandPublicGetByNameResponses,
    ShopAgentBrandPublicGetByNameErrors,
    ThrowOnError
  >({
    url: "/shop-agent/catalog/brand/public/get/{brand_name}",
    ...options,
  });
};

/**
 * List Brands Public
 *
 * Complete directory through Cosimo's authenticated customer API.
 */
export const shopAgentBrandPublicList = <ThrowOnError extends boolean = false>(
  options?: Options<ShopAgentBrandPublicListData, ThrowOnError>
) => {
  return (options?.client ?? client).get<ShopAgentBrandPublicListResponses, unknown, ThrowOnError>({
    url: "/shop-agent/catalog/brand/public/list",
    ...options,
  });
};

/**
 * Search Brands Index By Brands
 *
 * Public customer similarity, preserving the browser's snake_case result.
 */
export const shopAgentBrandIndexSearchByBrands = <ThrowOnError extends boolean = false>(
  options: Options<ShopAgentBrandIndexSearchByBrandsData, ThrowOnError>
) => {
  return (options.client ?? client).post<
    ShopAgentBrandIndexSearchByBrandsResponses,
    ShopAgentBrandIndexSearchByBrandsErrors,
    ThrowOnError
  >({
    url: "/shop-agent/catalog/brand/search-index/by-brands",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Search Brands Index From Text
 *
 * Platform owns understanding, ranking and generated-facet widening.
 */
export const shopAgentBrandIndexSearchFromText = <ThrowOnError extends boolean = false>(
  options: Options<ShopAgentBrandIndexSearchFromTextData, ThrowOnError>
) => {
  return (options.client ?? client).post<
    ShopAgentBrandIndexSearchFromTextResponses,
    ShopAgentBrandIndexSearchFromTextErrors,
    ThrowOnError
  >({
    url: "/shop-agent/catalog/brand/search-index/generate",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Search Brands Index From Query
 *
 * Optional Product-results Brand options through the customer Platform API.
 *
 * Project executed text and filters without understanding again. Numeric
 * quality and price bounds and Product style references are not forwarded.
 * Unsupported or over-budget contexts skip whole; errors remain failures.
 */
export const shopAgentBrandIndexSearchFromQuery = <ThrowOnError extends boolean = false>(
  options: Options<ShopAgentBrandIndexSearchFromQueryData, ThrowOnError>
) => {
  return (options.client ?? client).post<
    ShopAgentBrandIndexSearchFromQueryResponses,
    ShopAgentBrandIndexSearchFromQueryErrors,
    ThrowOnError
  >({
    url: "/shop-agent/catalog/brand/search-index/generate-from-query",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Search Brands Index By Prefix
 *
 * Customer-backed canonical names in Platform ranking order.
 */
export const shopAgentBrandIndexPrefixSearch = <ThrowOnError extends boolean = false>(
  options: Options<ShopAgentBrandIndexPrefixSearchData, ThrowOnError>
) => {
  return (options.client ?? client).get<
    ShopAgentBrandIndexPrefixSearchResponses,
    ShopAgentBrandIndexPrefixSearchErrors,
    ThrowOnError
  >({
    url: "/shop-agent/catalog/brand/search-index/prefix",
    ...options,
  });
};

/**
 * Get Product Group By Uuid
 *
 * Hydrate one saved product by uuid: ``/products/hydrate`` for one id.
 */
export const shopAgentCatalogGetProductGroupByUuid = <ThrowOnError extends boolean = false>(
  options: Options<ShopAgentCatalogGetProductGroupByUuidData, ThrowOnError>
) => {
  return (options.client ?? client).get<
    ShopAgentCatalogGetProductGroupByUuidResponses,
    ShopAgentCatalogGetProductGroupByUuidErrors,
    ThrowOnError
  >({
    url: "/shop-agent/catalog/get_product_group_by_uuid",
    ...options,
  });
};

/**
 * Browse Public Products By Brand
 *
 * Stable customer-scoped brand browsing; no native catalog fallback.
 */
export const shopAgentCatalogProductPublicBrowseByBrand = <ThrowOnError extends boolean = false>(
  options: Options<ShopAgentCatalogProductPublicBrowseByBrandData, ThrowOnError>
) => {
  return (options.client ?? client).get<
    ShopAgentCatalogProductPublicBrowseByBrandResponses,
    ShopAgentCatalogProductPublicBrowseByBrandErrors,
    ThrowOnError
  >({
    url: "/shop-agent/catalog/product/public/browse_by_brand",
    ...options,
  });
};

/**
 * Get Public Product By Uuid
 *
 * Fetch minimal public product details for SSR/SSG metadata and JSON-LD.
 *
 * Served from the cached ``/v1`` retrieve (``product_page``). The requested
 * id stays the served id's fallback; the retrieved current uuid is the
 * response ``uuid``, as the CatalogDB row's uuid was.
 */
export const shopAgentCatalogProductPublicGetByUuid = <ThrowOnError extends boolean = false>(
  options: Options<ShopAgentCatalogProductPublicGetByUuidData, ThrowOnError>
) => {
  return (options.client ?? client).get<
    ShopAgentCatalogProductPublicGetByUuidResponses,
    ShopAgentCatalogProductPublicGetByUuidErrors,
    ThrowOnError
  >({
    url: "/shop-agent/catalog/product/public/get_by_uuid",
    ...options,
  });
};

/**
 * Get Public Product Json Ld
 *
 * Return a pre-built Schema.org Product JSON-LD object for SSR injection.
 *
 * Served from the cached ``/v1`` retrieve (``product_page``), like
 * ``get_by_uuid``: the same uuid, 404/410 and 503 rules.
 */
export const shopAgentCatalogProductPublicJsonLd = <ThrowOnError extends boolean = false>(
  options: Options<ShopAgentCatalogProductPublicJsonLdData, ThrowOnError>
) => {
  return (options.client ?? client).get<
    ShopAgentCatalogProductPublicJsonLdResponses,
    ShopAgentCatalogProductPublicJsonLdErrors,
    ThrowOnError
  >({
    url: "/shop-agent/catalog/product/public/json-ld",
    ...options,
  });
};

/**
 * Get Public Product Status
 *
 * Return the lifecycle status of a product without loading its payload.
 *
 * The storefront middleware calls this on canonical PDP requests to answer
 * 410 for settled deactivations. Answered from the cached ``/v1`` retrieve,
 * which resolves historical and public ids to the current product. A
 * Platform failure is a 503; the middleware fails open on it.
 */
export const shopAgentCatalogProductPublicStatus = <ThrowOnError extends boolean = false>(
  options: Options<ShopAgentCatalogProductPublicStatusData, ThrowOnError>
) => {
  return (options.client ?? client).get<
    ShopAgentCatalogProductPublicStatusResponses,
    ShopAgentCatalogProductPublicStatusErrors,
    ThrowOnError
  >({
    url: "/shop-agent/catalog/product/public/status",
    ...options,
  });
};

/**
 * Hydrate Products
 *
 * Hydrate saved products (cart, collections, saved items) by uuid.
 *
 * Served from one ``/v1`` batch retrieve (``platform_surfaces.hydration``).
 * A missing product is a ``not_found`` result; a Platform failure is a 503
 * for the whole request.
 */
export const shopAgentCatalogHydrateProducts = <ThrowOnError extends boolean = false>(
  options: Options<ShopAgentCatalogHydrateProductsData, ThrowOnError>
) => {
  return (options.client ?? client).post<
    ShopAgentCatalogHydrateProductsResponses,
    ShopAgentCatalogHydrateProductsErrors,
    ThrowOnError
  >({
    url: "/shop-agent/catalog/products/hydrate",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Get Attributes By Facets
 *
 * Get aggregated attributes using category_path.depth_* facets.
 *
 * Builds the category path from facets and returns the aggregated attributes
 * for that category and all its descendants (same behavior as /aggregated).
 */
export const getAttributesByFacetsShopAgentCategoryAttributesAggregatedAttributesByFacetsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetAttributesByFacetsShopAgentCategoryAttributesAggregatedAttributesByFacetsPostData,
    ThrowOnError
  >
) => {
  return (options.client ?? client).post<
    GetAttributesByFacetsShopAgentCategoryAttributesAggregatedAttributesByFacetsPostResponses,
    GetAttributesByFacetsShopAgentCategoryAttributesAggregatedAttributesByFacetsPostErrors,
    ThrowOnError
  >({
    url: "/shop-agent/category-attributes/aggregated_attributes/by_facets",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Get Category Counts
 *
 * Get counts for one category hierarchy depth of one catalog.
 *
 * Counts come from Platform ``/v1`` and span the Cosimo key's scope: a
 * catalog outside it counts nothing. ``catalog='*'`` is rejected.
 */
export const getCategoryCountsShopAgentCategoryAttributesCategoryCountsPost = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetCategoryCountsShopAgentCategoryAttributesCategoryCountsPostData, ThrowOnError>
) => {
  return (options.client ?? client).post<
    GetCategoryCountsShopAgentCategoryAttributesCategoryCountsPostResponses,
    GetCategoryCountsShopAgentCategoryAttributesCategoryCountsPostErrors,
    ThrowOnError
  >({
    url: "/shop-agent/category-attributes/category-counts",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * List Collections For User
 *
 * List all collections for authenticated user (requires authentication via X-Octogen-User-ID header).
 */
export const listCollectionsForUserShopAgentCollectionsGet = <ThrowOnError extends boolean = false>(
  options?: Options<ListCollectionsForUserShopAgentCollectionsGetData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    ListCollectionsForUserShopAgentCollectionsGetResponses,
    ListCollectionsForUserShopAgentCollectionsGetErrors,
    ThrowOnError
  >({
    url: "/shop-agent/collections/",
    ...options,
  });
};

/**
 * Create Collection
 *
 * Create a new collection for authenticated user (requires authentication via X-Octogen-User-ID header).
 */
export const createCollectionShopAgentCollectionsPost = <ThrowOnError extends boolean = false>(
  options: Options<CreateCollectionShopAgentCollectionsPostData, ThrowOnError>
) => {
  return (options.client ?? client).post<
    CreateCollectionShopAgentCollectionsPostResponses,
    CreateCollectionShopAgentCollectionsPostErrors,
    ThrowOnError
  >({
    url: "/shop-agent/collections/",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Get Public Collection
 *
 * Get a public collection by ID (no auth, returns 404 if private).
 */
export const getPublicCollectionShopAgentCollectionsPublicCollectionIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetPublicCollectionShopAgentCollectionsPublicCollectionIdGetData, ThrowOnError>
) => {
  return (options.client ?? client).get<
    GetPublicCollectionShopAgentCollectionsPublicCollectionIdGetResponses,
    GetPublicCollectionShopAgentCollectionsPublicCollectionIdGetErrors,
    ThrowOnError
  >({
    url: "/shop-agent/collections/public/{collection_id}",
    ...options,
  });
};

/**
 * Delete Collection
 *
 * Delete a collection (requires authentication via X-Octogen-User-ID header, validates ownership).
 */
export const deleteCollectionShopAgentCollectionsCollectionIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteCollectionShopAgentCollectionsCollectionIdDeleteData, ThrowOnError>
) => {
  return (options.client ?? client).delete<
    DeleteCollectionShopAgentCollectionsCollectionIdDeleteResponses,
    DeleteCollectionShopAgentCollectionsCollectionIdDeleteErrors,
    ThrowOnError
  >({
    url: "/shop-agent/collections/{collection_id}",
    ...options,
  });
};

/**
 * Get Collection
 *
 * Get a collection by ID (requires authentication via X-Octogen-User-ID header, validates ownership).
 */
export const getCollectionShopAgentCollectionsCollectionIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetCollectionShopAgentCollectionsCollectionIdGetData, ThrowOnError>
) => {
  return (options.client ?? client).get<
    GetCollectionShopAgentCollectionsCollectionIdGetResponses,
    GetCollectionShopAgentCollectionsCollectionIdGetErrors,
    ThrowOnError
  >({
    url: "/shop-agent/collections/{collection_id}",
    ...options,
  });
};

/**
 * Update Collection
 *
 * Update a collection (requires authentication via X-Octogen-User-ID header, validates ownership).
 */
export const updateCollectionShopAgentCollectionsCollectionIdPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateCollectionShopAgentCollectionsCollectionIdPatchData, ThrowOnError>
) => {
  return (options.client ?? client).patch<
    UpdateCollectionShopAgentCollectionsCollectionIdPatchResponses,
    UpdateCollectionShopAgentCollectionsCollectionIdPatchErrors,
    ThrowOnError
  >({
    url: "/shop-agent/collections/{collection_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Revoke Connected App
 *
 * Revoke the caller's grants for one client; its next refresh fails.
 *
 * client_id is a query parameter: CIMD client IDs are URLs, and the gateway
 * rewrites escaped slashes in paths. Access tokens already issued stay valid
 * until they expire, within an hour.
 */
export const revokeConnectedAppShopAgentMcpConnectedAppsDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<RevokeConnectedAppShopAgentMcpConnectedAppsDeleteData, ThrowOnError>
) => {
  return (options.client ?? client).delete<
    RevokeConnectedAppShopAgentMcpConnectedAppsDeleteResponses,
    RevokeConnectedAppShopAgentMcpConnectedAppsDeleteErrors,
    ThrowOnError
  >({
    url: "/shop-agent/mcp/connected-apps",
    ...options,
  });
};

/**
 * List Connected Apps
 *
 * MCP clients holding a live grant for the caller, most recently used first.
 */
export const listConnectedAppsShopAgentMcpConnectedAppsGet = <ThrowOnError extends boolean = false>(
  options?: Options<ListConnectedAppsShopAgentMcpConnectedAppsGetData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    ListConnectedAppsShopAgentMcpConnectedAppsGetResponses,
    ListConnectedAppsShopAgentMcpConnectedAppsGetErrors,
    ThrowOnError
  >({
    url: "/shop-agent/mcp/connected-apps",
    ...options,
  });
};

/**
 * List Saved Brands For User
 *
 * List saved brands for the authenticated user.
 */
export const listSavedBrandsForUserShopAgentSavedBrandsGet = <ThrowOnError extends boolean = false>(
  options?: Options<ListSavedBrandsForUserShopAgentSavedBrandsGetData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    ListSavedBrandsForUserShopAgentSavedBrandsGetResponses,
    ListSavedBrandsForUserShopAgentSavedBrandsGetErrors,
    ThrowOnError
  >({
    url: "/shop-agent/saved-brands/",
    ...options,
  });
};

/**
 * Create Saved Brand
 *
 * Create a saved brand for the authenticated user.
 */
export const createSavedBrandShopAgentSavedBrandsPost = <ThrowOnError extends boolean = false>(
  options: Options<CreateSavedBrandShopAgentSavedBrandsPostData, ThrowOnError>
) => {
  return (options.client ?? client).post<
    CreateSavedBrandShopAgentSavedBrandsPostResponses,
    CreateSavedBrandShopAgentSavedBrandsPostErrors,
    ThrowOnError
  >({
    url: "/shop-agent/saved-brands/",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Get Saved Brand By Name
 *
 * Get a saved brand by brand name for the authenticated user.
 */
export const getSavedBrandByNameShopAgentSavedBrandsByNameBrandNameGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetSavedBrandByNameShopAgentSavedBrandsByNameBrandNameGetData, ThrowOnError>
) => {
  return (options.client ?? client).get<
    GetSavedBrandByNameShopAgentSavedBrandsByNameBrandNameGetResponses,
    GetSavedBrandByNameShopAgentSavedBrandsByNameBrandNameGetErrors,
    ThrowOnError
  >({
    url: "/shop-agent/saved-brands/by-name/{brand_name}",
    ...options,
  });
};

/**
 * Delete Saved Brand
 *
 * Delete a saved brand.
 */
export const deleteSavedBrandShopAgentSavedBrandsSavedBrandIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteSavedBrandShopAgentSavedBrandsSavedBrandIdDeleteData, ThrowOnError>
) => {
  return (options.client ?? client).delete<
    DeleteSavedBrandShopAgentSavedBrandsSavedBrandIdDeleteResponses,
    DeleteSavedBrandShopAgentSavedBrandsSavedBrandIdDeleteErrors,
    ThrowOnError
  >({
    url: "/shop-agent/saved-brands/{saved_brand_id}",
    ...options,
  });
};

/**
 * Update Saved Brand
 *
 * Update a saved brand.
 */
export const updateSavedBrandShopAgentSavedBrandsSavedBrandIdPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateSavedBrandShopAgentSavedBrandsSavedBrandIdPatchData, ThrowOnError>
) => {
  return (options.client ?? client).patch<
    UpdateSavedBrandShopAgentSavedBrandsSavedBrandIdPatchResponses,
    UpdateSavedBrandShopAgentSavedBrandsSavedBrandIdPatchErrors,
    ThrowOnError
  >({
    url: "/shop-agent/saved-brands/{saved_brand_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * List Saved Searches For User
 *
 * List saved searches for the authenticated user.
 */
export const listSavedSearchesForUserShopAgentSavedSearchesGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListSavedSearchesForUserShopAgentSavedSearchesGetData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    ListSavedSearchesForUserShopAgentSavedSearchesGetResponses,
    ListSavedSearchesForUserShopAgentSavedSearchesGetErrors,
    ThrowOnError
  >({
    url: "/shop-agent/saved-searches/",
    ...options,
  });
};

/**
 * Create Saved Search
 *
 * Create a saved dynamic search for the authenticated user.
 */
export const createSavedSearchShopAgentSavedSearchesPost = <ThrowOnError extends boolean = false>(
  options: Options<CreateSavedSearchShopAgentSavedSearchesPostData, ThrowOnError>
) => {
  return (options.client ?? client).post<
    CreateSavedSearchShopAgentSavedSearchesPostResponses,
    CreateSavedSearchShopAgentSavedSearchesPostErrors,
    ThrowOnError
  >({
    url: "/shop-agent/saved-searches/",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Delete Saved Search
 *
 * Delete a saved search.
 */
export const deleteSavedSearchShopAgentSavedSearchesSavedSearchIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteSavedSearchShopAgentSavedSearchesSavedSearchIdDeleteData, ThrowOnError>
) => {
  return (options.client ?? client).delete<
    DeleteSavedSearchShopAgentSavedSearchesSavedSearchIdDeleteResponses,
    DeleteSavedSearchShopAgentSavedSearchesSavedSearchIdDeleteErrors,
    ThrowOnError
  >({
    url: "/shop-agent/saved-searches/{saved_search_id}",
    ...options,
  });
};

/**
 * Update Saved Search
 *
 * Update a saved search.
 */
export const updateSavedSearchShopAgentSavedSearchesSavedSearchIdPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateSavedSearchShopAgentSavedSearchesSavedSearchIdPatchData, ThrowOnError>
) => {
  return (options.client ?? client).patch<
    UpdateSavedSearchShopAgentSavedSearchesSavedSearchIdPatchResponses,
    UpdateSavedSearchShopAgentSavedSearchesSavedSearchIdPatchErrors,
    ThrowOnError
  >({
    url: "/shop-agent/saved-searches/{saved_search_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * List User Search Queries
 *
 * Get recent search queries for the authenticated user.
 *
 * Returns the user's saved search queries, ordered by most recent first.
 * These queries can be used to recover search state and display search history.
 *
 * Args:
 * db: Database session
 * user_id: Authenticated user ID from X-Octogen-User-ID header
 * limit: Maximum number of queries to return (default: 50, max: 200)
 * offset: Number of queries to skip for pagination (default: 0)
 *
 * Returns:
 * SearchQueryListResponse with list of search queries and total count
 * for pagination support
 */
export const listUserSearchQueriesShopAgentSearchQueriesGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListUserSearchQueriesShopAgentSearchQueriesGetData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    ListUserSearchQueriesShopAgentSearchQueriesGetResponses,
    ListUserSearchQueriesShopAgentSearchQueriesGetErrors,
    ThrowOnError
  >({
    url: "/shop-agent/search-queries/",
    ...options,
  });
};

/**
 * Get Thread Latest Query
 *
 * Get the most recent search query for a specific thread.
 *
 * This is the primary endpoint for recovering search state when returning
 * to a results page. Returns the most recent search query for the thread.
 *
 * Args:
 * thread_id: The thread identifier
 * db: Database session
 * user_id: Authenticated user ID from X-Octogen-User-ID header
 *
 * Returns:
 * SearchQueryItem with the most recent search query for the thread
 *
 * Raises:
 * HTTPException: 404 if no queries found for thread or thread doesn't belong to user
 */
export const getThreadLatestQueryShopAgentSearchQueriesThreadsThreadIdLatestGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    GetThreadLatestQueryShopAgentSearchQueriesThreadsThreadIdLatestGetData,
    ThrowOnError
  >
) => {
  return (options.client ?? client).get<
    GetThreadLatestQueryShopAgentSearchQueriesThreadsThreadIdLatestGetResponses,
    GetThreadLatestQueryShopAgentSearchQueriesThreadsThreadIdLatestGetErrors,
    ThrowOnError
  >({
    url: "/shop-agent/search-queries/threads/{thread_id}/latest",
    ...options,
  });
};

/**
 * Get Search Query
 *
 * Retrieve a previously saved search query by its search_id or thread_id.
 *
 * This endpoint allows the frontend to recover search parameters
 * when session storage is unavailable (e.g., after clearing browser data
 * or opening a search link in a new browser).
 *
 * For agent-generated searches, the URL may contain the thread_id while the
 * search was saved with a different search_id. This endpoint first tries
 * to find by search_id, then falls back to thread_id lookup.
 *
 * Security Design:
 * This endpoint intentionally does NOT require authentication. This is a
 * deliberate design decision to support shareable search links:
 * - Users can share search result URLs with others
 * - The recipient can view the same search results without needing to log in
 * - Search queries contain only search parameters (text, facets, etc.),
 * not personally identifiable information
 * - The search_id is a UUID, making enumeration attacks impractical
 *
 * Args:
 * search_id: The identifier from the URL (may be search_id or thread_id)
 * db: Database session
 *
 * Returns:
 * The stored search (a ``/v1`` request)
 *
 * Raises:
 * HTTPException: 404 if search not found
 */
export const getSearchQueryShopAgentSearchQueriesSearchIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetSearchQueryShopAgentSearchQueriesSearchIdGetData, ThrowOnError>
) => {
  return (options.client ?? client).get<
    GetSearchQueryShopAgentSearchQueriesSearchIdGetResponses,
    GetSearchQueryShopAgentSearchQueriesSearchIdGetErrors,
    ThrowOnError
  >({
    url: "/shop-agent/search-queries/{search_id}",
    ...options,
  });
};

/**
 * Curated Search
 *
 * Execute a curated search by handle.
 *
 * Only accepts handles from the known curated-query registry; arbitrary
 * queries are rejected.  Uses aggressive L1 caching (10 min) for
 * near-instant repeat responses.  No authentication required. The stored
 * query runs as its ``/v1`` request; products are ``/v1``'s list items.
 */
export const curatedSearchShopAgentSearchCuratedPost = <ThrowOnError extends boolean = false>(
  options: Options<CuratedSearchShopAgentSearchCuratedPostData, ThrowOnError>
) => {
  return (options.client ?? client).post<
    CuratedSearchShopAgentSearchCuratedPostResponses,
    CuratedSearchShopAgentSearchCuratedPostErrors,
    ThrowOnError
  >({
    url: "/shop-agent/search/curated",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Get Home Curated Rails
 *
 * Return all home curated rails in one cached, bounded request.
 *
 * The homepage only needs a small display slice from each rail.  Running those
 * slices behind one endpoint avoids browser request fanout and lets the
 * backend bound search concurrency while still using the per-rail
 * curated-search caches.
 *
 * A product rail that ``/v1`` fails is left out and that response is served
 * uncached: the next request builds the rails again.
 */
export const getHomeCuratedRailsShopAgentSearchCuratedHomeGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetHomeCuratedRailsShopAgentSearchCuratedHomeGetData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetHomeCuratedRailsShopAgentSearchCuratedHomeGetResponses,
    GetHomeCuratedRailsShopAgentSearchCuratedHomeGetErrors,
    ThrowOnError
  >({
    url: "/shop-agent/search/curated/home",
    ...options,
  });
};

/**
 * List Curated Landing Pages
 *
 * Return SEO metadata for curated queries marked as landing pages.
 *
 * Public, no authentication required.  Used by the frontend ISR page
 * to resolve /shop/{handle} slugs and by sitemap generation.
 */
export const listLandingPagesShopAgentSearchCuratedLandingPagesGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ListLandingPagesShopAgentSearchCuratedLandingPagesGetData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    ListLandingPagesShopAgentSearchCuratedLandingPagesGetResponses,
    unknown,
    ThrowOnError
  >({
    url: "/shop-agent/search/curated/landing-pages",
    ...options,
  });
};

/**
 * Internal Search Products
 *
 * ``POST /shop-agent/search/products`` for server-to-server callers.
 *
 * Requires the X-Octogen-Internal-Token header. Serves server-rendered pages
 * and bridge routes, which hold a service token rather than a shopper
 * identity, so nothing is filed in search history.
 */
export const shopAgentSearchInternalProducts = <ThrowOnError extends boolean = false>(
  options: Options<ShopAgentSearchInternalProductsData, ThrowOnError>
) => {
  return (options.client ?? client).post<
    ShopAgentSearchInternalProductsResponses,
    ShopAgentSearchInternalProductsErrors,
    ThrowOnError
  >({
    url: "/shop-agent/search/internal/products",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Get Search Page
 *
 * The page 1 cached under ``search_id``, as ``POST /products`` served it.
 *
 * Requires authentication via the X-Octogen-User-ID header. Pass
 * ``nextCursor`` with the search's body to ``POST /products`` for the next
 * page. An unknown or malformed id is a 404.
 */
export const shopAgentGetSearchPage = <ThrowOnError extends boolean = false>(
  options: Options<ShopAgentGetSearchPageData, ThrowOnError>
) => {
  return (options.client ?? client).get<
    ShopAgentGetSearchPageResponses,
    ShopAgentGetSearchPageErrors,
    ThrowOnError
  >({
    url: "/shop-agent/search/pages/{search_id}",
    ...options,
  });
};

/**
 * Search Products
 *
 * Search products with a ``/v1`` request; answers in ``/v1``'s page shape.
 *
 * Requires authentication via the X-Octogen-User-ID header. Each item's
 * ``uuid`` is the id its Cosimo product URL uses. Pass ``nextCursor`` back
 * with the same body for the next page.
 */
export const shopAgentSearchProducts = <ThrowOnError extends boolean = false>(
  options: Options<ShopAgentSearchProductsData, ThrowOnError>
) => {
  return (options.client ?? client).post<
    ShopAgentSearchProductsResponses,
    ShopAgentSearchProductsErrors,
    ThrowOnError
  >({
    url: "/shop-agent/search/products",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Similar Products
 *
 * Products similar to a product, or to a collection's products as a set.
 *
 * A cursor ``/v1`` rejects is a 400 ``invalid cursor``; the client restarts
 * from page 1. Any other request ``/v1`` rejects (a facet or embedding column
 * it does not know) is a 400 ``invalid similar-products request``; other
 * ``/v1`` failures are a 503 with ``Retry-After``.
 */
export const shopAgentSearchSimilarProducts = <ThrowOnError extends boolean = false>(
  options: Options<ShopAgentSearchSimilarProductsData, ThrowOnError>
) => {
  return (options.client ?? client).post<
    ShopAgentSearchSimilarProductsResponses,
    ShopAgentSearchSimilarProductsErrors,
    ThrowOnError
  >({
    url: "/shop-agent/search/similar_products",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Get Cosimo Agent Threads
 *
 * List all Cosimo agent conversation threads for authenticated user (requires authentication via X-Octogen-User-ID header).
 *
 * Args:
 * user_id: Authenticated user ID from X-Octogen-User-ID header
 * checkpointer: The checkpointer dependency
 *
 * Returns:
 * List of Thread objects with summaries from thread_summaries table
 */
export const getCosimoAgentThreadsShopAgentThreadsCosimoAgentGet = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<GetCosimoAgentThreadsShopAgentThreadsCosimoAgentGetData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetCosimoAgentThreadsShopAgentThreadsCosimoAgentGetResponses,
    GetCosimoAgentThreadsShopAgentThreadsCosimoAgentGetErrors,
    ThrowOnError
  >({
    url: "/shop-agent/threads/cosimo-agent",
    ...options,
  });
};

/**
 * Delete Cosimo Agent Thread
 *
 * Delete a Cosimo agent conversation thread (requires authentication via X-Octogen-User-ID header).
 *
 * Args:
 * thread_id: The thread ID to delete
 * user_id: Authenticated user ID from X-Octogen-User-ID header
 * checkpointer: The checkpointer dependency
 *
 * Returns:
 * Success status and count of deleted items
 *
 * Raises:
 * HTTPException: 404 if thread not found
 */
export const deleteCosimoAgentThreadShopAgentThreadsCosimoAgentThreadIdDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    DeleteCosimoAgentThreadShopAgentThreadsCosimoAgentThreadIdDeleteData,
    ThrowOnError
  >
) => {
  return (options.client ?? client).delete<
    DeleteCosimoAgentThreadShopAgentThreadsCosimoAgentThreadIdDeleteResponses,
    DeleteCosimoAgentThreadShopAgentThreadsCosimoAgentThreadIdDeleteErrors,
    ThrowOnError
  >({
    url: "/shop-agent/threads/cosimo-agent/{thread_id}",
    ...options,
  });
};

/**
 * Get Shop Agent Chat History
 *
 * Get full chat history for a specific shop agent thread (requires authentication via X-Octogen-User-ID header).
 *
 * Args:
 * thread_id: The thread ID to get history for
 * user_id: Authenticated user ID from X-Octogen-User-ID header
 * checkpointer: The checkpointer dependency
 *
 * Returns:
 * ChatHistory for the specified thread with title from thread_summaries
 */
export const getShopAgentChatHistoryShopAgentThreadsShopAgentThreadIdGet = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetShopAgentChatHistoryShopAgentThreadsShopAgentThreadIdGetData, ThrowOnError>
) => {
  return (options.client ?? client).get<
    GetShopAgentChatHistoryShopAgentThreadsShopAgentThreadIdGetResponses,
    GetShopAgentChatHistoryShopAgentThreadsShopAgentThreadIdGetErrors,
    ThrowOnError
  >({
    url: "/shop-agent/threads/shop-agent/{thread_id}",
    ...options,
  });
};

/**
 * Get User
 *
 * Get current user profile (requires authentication via X-Octogen-User-ID header).
 */
export const getUserShopAgentUsersMeGet = <ThrowOnError extends boolean = false>(
  options?: Options<GetUserShopAgentUsersMeGetData, ThrowOnError>
) => {
  return (options?.client ?? client).get<
    GetUserShopAgentUsersMeGetResponses,
    GetUserShopAgentUsersMeGetErrors,
    ThrowOnError
  >({
    url: "/shop-agent/users/me",
    ...options,
  });
};

/**
 * Update User
 *
 * Update current user profile (requires authentication via X-Octogen-User-ID header).
 */
export const updateUserShopAgentUsersMePatch = <ThrowOnError extends boolean = false>(
  options: Options<UpdateUserShopAgentUsersMePatchData, ThrowOnError>
) => {
  return (options.client ?? client).patch<
    UpdateUserShopAgentUsersMePatchResponses,
    UpdateUserShopAgentUsersMePatchErrors,
    ThrowOnError
  >({
    url: "/shop-agent/users/me",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Create User
 *
 * Create current user profile (requires authentication via X-Octogen-User-ID header).
 *
 * User ID is extracted from X-Octogen-User-ID header (set by API Gateway in production,
 * or manually in dev mode). This is the single source of truth for user identity.
 */
export const createUserShopAgentUsersMePost = <ThrowOnError extends boolean = false>(
  options: Options<CreateUserShopAgentUsersMePostData, ThrowOnError>
) => {
  return (options.client ?? client).post<
    CreateUserShopAgentUsersMePostResponses,
    CreateUserShopAgentUsersMePostErrors,
    ThrowOnError
  >({
    url: "/shop-agent/users/me",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Update User Preferences
 *
 * Add or remove items from current user preference arrays (requires authentication via X-Octogen-User-ID header).
 *
 * Args:
 * preference_type: Type of preference ('tops', 'bottoms', 'shoes', or 'brands')
 * payload: Contains items to add/remove and the action to perform
 * user_id: Authenticated user ID from X-Octogen-User-ID header
 * db: Database session
 *
 * Returns:
 * Updated User model
 *
 * Raises:
 * HTTPException: If user not found or invalid preference type
 */
export const updateUserPreferencesShopAgentUsersMePreferencesPreferenceTypePatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    UpdateUserPreferencesShopAgentUsersMePreferencesPreferenceTypePatchData,
    ThrowOnError
  >
) => {
  return (options.client ?? client).patch<
    UpdateUserPreferencesShopAgentUsersMePreferencesPreferenceTypePatchResponses,
    UpdateUserPreferencesShopAgentUsersMePreferencesPreferenceTypePatchErrors,
    ThrowOnError
  >({
    url: "/shop-agent/users/me/preferences/{preference_type}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};
